import { useTranslation } from "react-i18next";
import React from "react";
import StatusBadge from "./StatusBadge";
export const StatusColor = {
  default: "bg-gray-100 text-gray-700 border-gray-200",
  pending: "bg-orange-100 text-orange-700/70 border-orange-200",
  completed: "bg-green-100 text-green-700 border-green-200",
  paid: "bg-green-100 text-green-700 border-green-200",
  failed: "bg-rose-100 text-rose-700 border-rose-200",
  expired: "bg-rose-100 text-rose-700 border-rose-200",
  refunded: "bg-orange-200 text-orange-700/70 border-orange-200",
  canceled: "bg-rose-200 text-rose-700/70 border-rose-200",
  on_hold: "bg-rose-700 text-rose-100 border-rose-100",
  "in progress": "bg-pink-100 text-pink-700 border-pink-200",
  active: "bg-green-100 text-green-700 border-green-200",
  inactive: "bg-rose-100 text-rose-700 border-rose-200",
  accepted: "bg-green-100 text-green-700 border-green-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
  Yes: "bg-green-100 text-green-700 border-green-200",
  No: "bg-rose-100 text-rose-700 border-rose-200",
  not_found: "bg-rose-100 text-rose-700 border-rose-200",
  unknown_error: "bg-rose-100 text-rose-700 border-rose-200",
};
function ArrayStatusBadge({ statusList, boolean, w, h }) {
  const { t } = useTranslation();
  if (!statusList || statusList.length === 0) {
    return (
      <div className="text-slate-400 font-bold text-[10px] uppercase tracking-widest">
        {t("No members")}
      </div>
    );
  }

  // Count occurrences of each status
  const statusCounts = {
    true: 0,
    false: 0,
    null: 0,
  };
  let totalCount = 0;
  for (const status of statusList) {
    totalCount++;
    if (status === true) {
      statusCounts.true++;
    } else if (status === false) {
      statusCounts.false++;
    } else if (status === null) {
      statusCounts.null++;
    }
  }

  // Determine the dominant status (prioritize showing issues)
  let dominantStatus;

  // If there are any failures, show that first
  if (statusCounts.false > 0) {
    dominantStatus = false;
  }
  // If there are pending items and no failures, show pending
  else if (statusCounts.null > 0) {
    dominantStatus = null;
  }
  // If everything is successful, show success
  else if (statusCounts.true > 0) {
    dominantStatus = true;
  }
  // Fallback (shouldn't happen with the checks above)
  else {
    dominantStatus = null;
  }

  // Create a summary text
  let summaryText = t("{{count}} members", { count: totalCount });
  if (
    boolean &&
    (statusCounts.true > 0 || statusCounts.false > 0 || statusCounts.null > 0)
  ) {
    const parts = [];
    if (statusCounts.true > 0) {
      parts.push(t("{{count}} success", { count: statusCounts.true }));
    }
    if (statusCounts.false > 0) {
      parts.push(t("{{count}} failed", { count: statusCounts.false }));
    }
    if (statusCounts.null > 0) {
      parts.push(t("{{count}} pending", { count: statusCounts.null }));
    }
    summaryText = parts.join(", ");
  }

  // Create a summary display
  return (
    <div className="flex items-center gap-2" title={`${summaryText}`}>
      <StatusBadge h={h} w={w} status={dominantStatus} boolean={boolean} />
      <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
        {summaryText}
      </span>
    </div>
  );
}
export default ArrayStatusBadge;
